import React, { Component } from 'react'
import PropTypes from 'prop-types'

import GFooter from 'grommet/components/Footer'
import Paragraph from 'grommet/components/Paragraph'

import BackButton from './BackButton'
import HomeButton from './HomeButton'

import '../styles/Footer.css'

class Footer extends Component {
  render () {
    const {
      history,
      isRoot
    } = this.props

    return (
      <GFooter className='Footer' justify='center' primary>
        <Paragraph margin='small' align='center'>
          &copy; Copyright {new Date().getFullYear()} Hewlett Packard Enterprise Development LP
        </Paragraph>
        <div className='ControlContainer'>
          <BackButton
            history={history}
            isRoot={isRoot}
            style={{
              marginRight: 10
            }} />

          <HomeButton
            history={history}
            isRoot={isRoot} />
        </div>
      </GFooter>
    )
  }
}

Footer.propTypes = {
  history: PropTypes.object,
  isRoot: PropTypes.bool
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js